import type { ActiveNode } from '../blockControlsPluginType';

export type BlockControlsLeftSurfaceTarget = {
	position: number;
	source: 'active' | 'root' | 'stored';
};

/** Combines hover-driven and stored surface positions into one deduplicated list. */
export const getBlockControlsLeftSurfaceTargets = (
	activeNode: ActiveNode | undefined,
	storedPositions: readonly number[],
): readonly BlockControlsLeftSurfaceTarget[] => {
	const targetsByPosition = new Map<number, BlockControlsLeftSurfaceTarget>();

	for (const position of storedPositions) {
		targetsByPosition.set(position, {
			position,
			source: 'stored',
		});
	}

	if (activeNode) {
		const rootPosition = activeNode.rootPos ?? activeNode.pos;
		targetsByPosition.set(rootPosition, {
			position: rootPosition,
			source: 'root',
		});

		if (activeNode.pos !== rootPosition) {
			targetsByPosition.set(activeNode.pos, {
				position: activeNode.pos,
				source: 'active',
			});
		}
	}

	return Array.from(targetsByPosition.values()).sort(
		(first, second) => first.position - second.position,
	);
};
